import { Injectable } from '@angular/core';
import { Http,Response, Headers,RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/catch';
import {Observable} from "rxjs";
import {Traslado} from "../traslado/traslado";
import {AuthenticationService} from "../Login/authentication.service";
import {UrlService} from "./url.service";






@Injectable()
export class TrasladoService
{

  private headers = new Headers({'Content-Type':'application/json',
    'Authorization': 'Bearer ' + this.authenticationService.token  });//parametrizamos a json
  private options = new RequestOptions({ headers: this.headers });
  private url = this.URL.getLocal()+'/traslado';//Url que maeja GET ,POST
  private urlAddDetalle = this.URL.getLocal()+'/traslado/detalle';//Url que maeja GET ,POST
  private urlDetByTraslado = this.URL.getLocal()+'/traslado/detalle/';//busca los archivos de un Traslado por id
  private urlDeleteFile = this.URL.getLocal()+'/traslado/archivo/eliminar/';//la direccion para borrar archivos
  private urlPut = this.URL.getLocal()+'/traslado/';//la direccion a la cual se conecta


  //Constructor de la clase
  constructor(private URL:UrlService,private http:Http, private authenticationService: AuthenticationService)
  {
    //this.headers.append('Content-Type', 'application/x-www-form-urlencoded');
    //this.headers.append('X-Requested-With', 'XMLHttpRequest');
  }
  //Obtiene una lista de Traslados
  getTraslado():Observable<Traslado[]> {
    let url = `${this.url}`;
    return this.http.get(url,this.options)
      .map(r => r.json())
      .catch(this.handleError)
  }
  getDetallesByTraslado(id: number): Observable<any[]> {
    let url = `${this.urlDetByTraslado}${id}`;
    return this.http.get(url, this.options)
      .first()
      .map(r => r.json())
      .catch(this.handleError)
  }

  addTraslado(Traslado:Traslado) {
    let url = `${this.url}`;
    let iJson = JSON.stringify(Traslado);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  addDetalleTraslado(dato:any) {
    let url = `${this.urlAddDetalle}`;
    let iJson = JSON.stringify(dato);
    return this.http.post(url,iJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);

  }
  putTraslado(Traslado : Traslado,id:number){
    let url = `${this.urlPut}${id}`;
    let CJson = JSON.stringify(Traslado);
    return this.http.put(url,CJson,this.options)
      .map(r => r.json())
      .catch(this.handleError);
  }
//Este metodo detecta un error en la llamada a http
  private handleError(error : Response | any) {
    let errMsj : string;
    if(error instanceof Response)
    {
      let body  = error.json() || '';
      let err = body.error || JSON.stringify(body);
      errMsj = `${error.status} - ${error.statusText || ''} ${err}`;
    }
    else
    {
      errMsj = error.message ? error.message : error.Tostring();
    }
    return Observable.throw(errMsj);
  }
}



// WEBPACK FOOTER //
// H:/Proyectos Galeras Indie/Vinta/vinta Tinka/VintaWebClient/src/app/Services/traslado.service.ts